export const h1 =
  'text-3xl font-bold leading-tight tracking-tighter md:text-4xl lg:leading-[1.1]';
